<template>
  <div id="products"
       ref="productsWall"
       :class="['product-wall', { 'is-mobile': isMobile, 'is-paused': state.pauseWall }]">
    <article v-if="isMobile"
             class="column column-mobile">
      <div ref="wallTracks"
           :class="['track', 'track-mobile', { 'track-paused': state.pauseWall }]"
           @mousedown="onWallDragStart"
           @mousemove="onWallDragMove"
           @mouseup="onWallDragEnd"
           @mouseleave="onWallDragEnd"
           @touchstart="onWallDragStart"
           @touchmove="onWallDragMove"
           @touchend="onWallDragEnd"
           @touchcancel="onWallDragEnd">
        <div v-for="(item, ii) in mobileWallRows"
             :key="item._mkey + '-' + ii"
             class="find-card"
             @click.prevent="openLink(item)">
          <span class="chip">
            Featured
          </span>
          <div class="thumb">
            <img :src="item.goodsImage"
                 :alt="item.goodsName"
                 loading="lazy"
                 width="800"
                 height="800" />

            <div class="thumb__tag"
                 v-if="item.tag">
              <div class="tag-marquee">
                <p class="tag-marquee__track">
                  <span class="tag-txt">
                    {{ item.tag }}
                  </span>
                  <span class="tag-txt tag-txt--dup"
                        aria-hidden="true">
                    {{ item.tag }}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <h3 class="t2-ell">
            {{ item.goodsName }}
          </h3>
          <h3 class="t2-price">
            <span style="margin-right: -9px">
              {{ item.currencySymbol || '$' }}
            </span>
            {{ item.price }}
          </h3>
          <!-- 购买按钮：stop 阻止冒泡到卡片点击，避免 openLink 执行两次 -->
          <button type="button"
                  @click.prevent.stop="openLink(item)">
            buy on {{ selectPlatform?.platformName }}
          </button>
        </div>
      </div>
    </article>

    <article v-else
             v-for="(rev, ci) in colReverse"
             :key="'col-' + ci"
             :class="['column', { reverse: rev }]">
      <div ref="wallTracks"
           :class="['track', { 'track-paused': state.pauseWall }]">
        <div v-for="(item, ii) in wallRows"
             :key="'c' + ci + '-' + ii + '-' + item._key"
             class="find-card"
             @click.prevent="openLink(item)">
          <span class="chip">
            Featured
          </span>
          <div class="thumb">
            <img :src="item.goodsImage"
                 :alt="item.goodsName"
                 loading="lazy"
                 width="800"
                 height="800" />

            <div class="thumb__tag"
                 v-if="item.tag">
              <div class="tag-marquee">
                <p class="tag-marquee__track">
                  <span class="tag-txt">
                    {{ item.tag }}
                  </span>
                  <span class="tag-txt tag-txt--dup"
                        aria-hidden="true">
                    {{ item.tag }}
                  </span>
                </p>
              </div>
            </div>
          </div>
          <h3 class="t2-ell">
            {{ item.goodsName }}
          </h3>
          <h3 class="t2-price">
            <span style="margin-right: -9px">
              {{ item.currencySymbol || '$' }}
            </span>
            {{ item.price }}
          </h3>
          <!-- 购买按钮：stop 阻止冒泡到卡片点击，避免 openLink 执行两次 -->
          <button class="buy"
                  type="button"
                  @click.prevent.stop="openLink(item)">
            buy on {{ selectPlatform?.platformName }}
          </button>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { setupSeamlessTrack, setupHorizontalTrack } from '../../finds-marquee'
import { openPlatformBuy, reportGoodsClick } from '@/utils/goodsAction'

/**
 * 首页首屏商品墙：负责卡片渲染、滚动 marquee 与入场动画
 */
export default {
  name: 'HomeProductWall',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    lockMobile: {
      type: Boolean,
      default: false
    },
    shelfItems: {
      type: Array,
      default: () => []
    },
    colReverse: {
      type: Array,
      default: () => [false, true, false]
    },
    selectPlatform: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      state: {
        //  控制暂停滚动
        pauseWall: false
      },
      _marqueeInited: false,
      // 拖拽相关状态
      dragState: {
        isActive: false,
        lockAxis: '',
        startX: 0,
        startY: 0,
        lastX: 0,
        lastTime: 0,
        velocity: 0,
        startCurrentTime: 0,
        moved: false
      },
      _inertiaRaf: null
    }
  },
  computed: {
    wallRows() {
      const s = this.shelfItems.map((row, i) => ({ ...row, _key: 's' + i }))
      if (this.lockMobile) {
        return s.slice(0, 10)
      }
      return [...s, ...s, ...s, ...s]
    },
    mobileWallRows() {
      if (this.lockMobile) {
        return this.wallRows.map((item, idx) => ({
          ...item,
          _mkey: `m-lite-${idx}-${item._key}`
        }))
      }
      const base = [...this.wallRows, ...this.wallRows, ...this.wallRows]
      return base.map((item, idx) => ({
        ...item,
        _mkey: `m-${idx}-${item._key}`
      }))
    },
    periodLen() {
      return this.shelfItems.length
    },
    mobilePeriodLen() {
      return this.mobileWallRows.length
    }
  },
  watch: {
    isMobile() {
      this._marqueeInited = false
      this.teardownMarquees()
      this.$nextTick(() => {
        this.refreshMarquees()
      })
    },
    lockMobile() {
      this._marqueeInited = false
      this.teardownMarquees()
      this.$nextTick(() => {
        this.refreshMarquees()
      })
    },
    'state.pauseWall'() {
      this.syncWallPauseState()
    },
    shelfItems() {
      this.$nextTick(() => {
        this.initTagMarquees()
      })
    },
    selectPlatform: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          this.updatePlatformButtons()
        })
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initShelfZoomIn()
      this.refreshMarquees()
      this.initTagMarquees()
    })
  },
  beforeDestroy() {
    this.teardownMarquees()
    this.stopInertia()
  },
  methods: {
    // 立即购买
    openLink(goods) {
      reportGoodsClick(goods)
      openPlatformBuy(this.selectPlatform, goods)
    },

    teardownMarquees() {
      const tracks = this.$refs.wallTracks
      const arr = Array.isArray(tracks) ? tracks : tracks ? [tracks] : []
      arr.forEach((t) => {
        if (t && t._marquee) {
          t._marquee.cancel()
          t._marquee = null
        }
      })
    },
    refreshMarquees() {
      if (this._marqueeInited) return
      this.teardownMarquees()
      this.$nextTick(() => {
        const tracks = this.$refs.wallTracks
        const arr = Array.isArray(tracks) ? tracks : tracks ? [tracks] : []
        arr.forEach((tr) => {
          if (this.isMobile) {
            setupHorizontalTrack(tr, this.mobilePeriodLen)
            this.tuneLockMobileSpeed(tr)
            return
          }
          setupSeamlessTrack(tr, this.periodLen)
        })
        this.syncWallPauseState()
        this._marqueeInited = true
        this.initTagMarquees()
        this.updatePlatformButtons()
      })
    },
    /** 标签文案超出容器宽度时启用横向循环滚动 */
    initTagMarquees() {
      const wall = this.$refs.productsWall
      if (!wall) return
      const tags = wall.querySelectorAll('.thumb__tag')
      tags.forEach((tag) => {
        tag.classList.remove('is-scroll')
        const box = tag.querySelector('.tag-marquee')
        const track = tag.querySelector('.tag-marquee__track')
        const single = tag.querySelector('.tag-txt:not(.tag-txt--dup)')
        if (!box || !track || !single) return
        if (single.scrollWidth > box.clientWidth) {
          tag.classList.add('is-scroll')
          const duration = Math.max(4, track.scrollWidth / 40)
          track.style.setProperty('--tag-dur', `${duration}s`)
        } else {
          track.style.removeProperty('--tag-dur')
        }
      })
    },
    tuneLockMobileSpeed(track) {
      if (!this.lockMobile || !track || !track._marquee) return
      const marquee = track._marquee
      const timing = marquee.effect?.getComputedTiming?.() || {}
      const currentDuration = Number(timing.duration) || 0
      const currentTime = Number(marquee.currentTime) || 0
      // iOS 锁定小屏模式下固定为 45s 一圈，避免基础时长过大导致“看起来没动”。
      const targetDuration = 45000
      if (marquee.effect?.updateTiming && currentDuration > 0) {
        const progress = currentTime / currentDuration
        marquee.effect.updateTiming({ duration: targetDuration })
        marquee.currentTime = targetDuration * progress
        return
      }
      marquee.playbackRate = 6
    },
    syncWallPauseState() {
      const tracks = this.$refs.wallTracks
      const arr = Array.isArray(tracks) ? tracks : tracks ? [tracks] : []
      arr.forEach((tr) => {
        if (!tr || !tr._marquee) return
        if (this.state.pauseWall) {
          tr._marquee.pause()
          return
        }
        tr._marquee.play()
      })
    },
    initShelfZoomIn() {
      const wall = this.$refs.productsWall
      if (!wall) return
      const cards = wall.querySelectorAll('.find-card')
      cards.forEach((card, idx) => {
        card.classList.add('shelf-card-zoom-in')
        card.style.setProperty('--shelf-zoom-delay', `${Math.min(idx, 14) * 65}ms`)
      })
    },

    updatePlatformButtons() {
      const wall = this.$refs.productsWall
      if (!wall) return
      const platformName = this.selectPlatform?.platformName || ''
      const buttons = wall.querySelectorAll('.find-card button')
      buttons.forEach((btn) => {
        btn.textContent = `buy on ${platformName}`
      })
    },

    getClientPoint(event) {
      if (event.touches && event.touches.length) {
        return event.touches[0]
      }
      if (event.changedTouches && event.changedTouches.length) {
        return event.changedTouches[0]
      }
      return event
    },
    getMobileTrack() {
      const tracks = this.$refs.wallTracks
      if (Array.isArray(tracks)) {
        return tracks.find((item) => item && item.classList.contains('track-mobile')) || null
      }
      return tracks || null
    },
    getMarqueeMeta(track) {
      const marquee = track && track._marquee
      if (!marquee || !marquee.effect || typeof marquee.effect.getKeyframes !== 'function') return null
      const keyframes = marquee.effect.getKeyframes()
      const targetFrame = keyframes[keyframes.length - 1] || {}
      const transformText = String(targetFrame.transform || '')
      const match = transformText.match(/translateX\((-?[\d.]+)px\)/)
      if (!match) return null
      const loopDistance = Math.abs(Number(match[1]))
      const timing = marquee.effect.getComputedTiming()
      const duration = Number(timing.duration) || 0
      if (!loopDistance || !duration) return null
      return {
        loopDistance,
        duration,
        msPerPx: duration / loopDistance
      }
    },
    onWallDragStart(event) {
      if (!this.isMobile) return
      const track = this.getMobileTrack()
      if (!track || !track._marquee) return
      this.stopInertia()
      const point = this.getClientPoint(event)
      this.dragState.isActive = true
      this.dragState.lockAxis = ''
      this.dragState.startX = point.clientX
      this.dragState.startY = point.clientY
      this.dragState.lastX = point.clientX
      this.dragState.lastTime = Date.now()
      this.dragState.velocity = 0
      this.dragState.startCurrentTime = Number(track._marquee.currentTime) || 0
      this.dragState.moved = false
      this.state.pauseWall = true
    },
    onWallDragMove(event) {
      if (!this.isMobile || !this.dragState.isActive) return
      const track = this.getMobileTrack()
      if (!track || !track._marquee) return
      const meta = this.getMarqueeMeta(track)
      if (!meta) return
      const point = this.getClientPoint(event)
      const moveX = point.clientX - this.dragState.startX
      const moveY = point.clientY - this.dragState.startY
      if (!this.dragState.lockAxis) {
        if (Math.abs(moveX) < 6 && Math.abs(moveY) < 6) return
        this.dragState.lockAxis = Math.abs(moveX) >= Math.abs(moveY) ? 'x' : 'y'
      }
      if (this.dragState.lockAxis !== 'x') {
        this.dragState.isActive = false
        this.state.pauseWall = false
        return
      }
      if (event.cancelable) {
        event.preventDefault()
      }
      const stepX = point.clientX - this.dragState.lastX
      const now = Date.now()
      const dt = now - this.dragState.lastTime
      this.dragState.lastX = point.clientX
      this.dragState.lastTime = now
      this.dragState.moved = true
      if (dt > 0) {
        this.dragState.velocity = stepX / dt
      }
      const nextTime = (Number(track._marquee.currentTime) || 0) - stepX * meta.msPerPx
      track._marquee.currentTime = nextTime
    },
    onWallDragEnd() {
      if (!this.dragState.isActive) return
      this.dragState.isActive = false
      this.dragState.lockAxis = ''
      const velocity = this.dragState.velocity
      if (Math.abs(velocity) > 0.1) {
        this.startInertia(velocity)
      } else {
        this.state.pauseWall = false
      }
    },
    stopInertia() {
      if (this._inertiaRaf) {
        cancelAnimationFrame(this._inertiaRaf)
        this._inertiaRaf = null
      }
    },
    startInertia(initialVelocity) {
      const track = this.getMobileTrack()
      if (!track || !track._marquee) {
        this.state.pauseWall = false
        return
      }
      const meta = this.getMarqueeMeta(track)
      if (!meta) {
        this.state.pauseWall = false
        return
      }
      let velocity = initialVelocity * 600
      const friction = 0.98
      const minVelocity = 0.3
      const step = () => {
        if (Math.abs(velocity) < minVelocity) {
          this._inertiaRaf = null
          this.state.pauseWall = false
          return
        }
        if (!track || !track._marquee) {
          this._inertiaRaf = null
          this.state.pauseWall = false
          return
        }
        const currentTime = Number(track._marquee.currentTime) || 0
        const pxPerMs = 1 / meta.msPerPx
        const deltaTime = -velocity * pxPerMs * 16
        track._marquee.currentTime = currentTime + deltaTime
        velocity *= friction
        this._inertiaRaf = requestAnimationFrame(step)
      }
      this._inertiaRaf = requestAnimationFrame(step)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/type1-style.scss';
@import '../../styles/find-base.css';

/* 商品标题最多显示两行，超出省略 */
.t2-ell {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.t2-price {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--accent);
}

.buy {
  padding: 0.2rem;
  font-size: 1rem;
}

/* 角标：最大 60% 宽，单行超出循环滚动 */
.product-wall :deep(.thumb__tag) {
  max-width: 50%;
}

.tag-marquee {
  overflow: hidden;
  width: 100%;
}

.tag-marquee__track {
  display: inline-flex;
  align-items: center;
  width: max-content;
  max-width: none;
  margin: 0;
  white-space: nowrap;
  animation: none;
}

.product-wall :deep(.thumb .thumb__tag .tag-txt) {
  background: linear-gradient(90deg,
      var(--primary-color) 0%,
      var(--primary-color) 40%,
      #fff 50%,
      var(--primary-color) 60%,
      var(--primary-color) 100%);
  background-size: 300% 100%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  animation: textBg 4s ease infinite;
}

.tag-txt {
  flex: 0 0 auto;
}

.thumb__tag:not(.is-scroll) .tag-txt--dup {
  display: none;
}

.thumb__tag.is-scroll .tag-txt--dup {
  padding-left: 1.25em;
}

.thumb__tag.is-scroll .tag-marquee__track {
  animation: tagMarquee var(--tag-dur, 6s) linear infinite;
}

@keyframes tagMarquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@media (max-width: 980px) {
  .t2-ell {
    height: 3.1rem;
    line-height: 1.4rem;
  }
}
</style>
